export default (function () {

  fitvids('.js-ma-responsive-video');

})();